import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "contaminantes",
    "contaminante",
    "ContaminanteForm",
    "/contaminantes",
);

export default handleActions(reducers, initialState);
